(() => {
  const KEY_ATTR = "data-go-key";
  const VAL_ATTR = "data-go-value";

  function applyActiveStates(root = document) {
    const url = new URL(window.location.href);
    const sp = url.searchParams;

    root.querySelectorAll("[data-go-filter]").forEach((btn) => {
      const key = btn.getAttribute(KEY_ATTR);
      const val = btn.getAttribute(VAL_ATTR) || "";
      const current = sp.get(key) || "";

      const on = (val === "" && !current) || (val !== "" && current === val);
      btn.classList.toggle("is-on", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  function setFilter(key, val) {
    const url = new URL(window.location.href);
    const sp = url.searchParams;

    // Toggle behavior:
    // - Clicking selected option clears that filter
    const current = sp.get(key) || "";
    const next = (current === (val || "")) ? "" : (val || "");

    // Clear pagination when filtering
    sp.delete("page");

    if (!next) sp.delete(key);
    else sp.set(key, next);

    // IMPORTANT: keep sort_by etc intact automatically
    window.location.href = url.toString();
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-go-filter]");
    if (!btn) return;

    e.preventDefault();

    const key = btn.getAttribute(KEY_ATTR);
    const val = btn.getAttribute(VAL_ATTR) || "";
    if (!key) return;

    setFilter(key, val);
  });

  document.addEventListener("DOMContentLoaded", () => applyActiveStates());
})();
